import { ImageGallery } from './ImageGallery';

/**
 * @type {NodeListOf<HTMLElement>}
 */
const imageGallery = document.querySelectorAll('.tx-avmplugins-gallery')
imageGallery.forEach((element) => {
    new ImageGallery(element);
})
